const VARIANT = process.env.REACT_APP_WHICH === 'nyserda' ? 'nyserda' : 'portal';

const variant = () => VARIANT;

export default variant;
